import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/EditLinkedSpecificationWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import * as _ from 'lodash';
import AddDocumentIcon from '../assets/images/add-document-60x60.svg';
import {
  readCompanyMember,
  updateHrFile,
} from '../redux/actions/table/my_company_members';
import EditMyCompanyMemberFileFolderForm from '../forms/edit_my_company_member_file_folder_wizard/EditMyCompanyMemberFileFolderForm';

@mapStateToProps((state) => ({
  store: _.get(state.table, 'my_company_members'),
}))
@withRouter
class EditMyCompanyMemberFileFolderWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    const file_name = this.props.store.file_name;
    const id = this.props.store.file_id;

    formData = {
      ...formData,
      id,
      file_name,
    };

    return validateForm(
      updateHrFile({ files: [formData] }).then(() =>
        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              'A my company member file folder has been updated.'
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        )
      )
    );
  }

  render() {
    const { folder_id, description } = this.props.store;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>
              {__(
                'wizard.my-company-members.title.edit-my-company-member-folder-file'
              )}
            </span>
            <span>
              {__(
                'wizard.my-company-members.subtitle.edit-my-company-member-folder-file'
              )}
            </span>
          </div>
          <div className={styles.right}>
            <AddDocumentIcon />
          </div>
        </div>
        <div className={styles.body}>
          <EditMyCompanyMemberFileFolderForm
            onSubmit={this._handleSubmit}
            initialValues={{
              folder_id,
              description,
            }}
          />
        </div>
      </>
    );
  }
}

export default EditMyCompanyMemberFileFolderWizard;
